




import Vue from "vue";
import Component from "vue-class-component";
import { LGeoJson } from "vue2-leaflet";
import { Icon, marker, Layer, LeafletMouseEvent, LatLng } from "leaflet";
import { IBaseStation } from "@/store/targets/models";
import { targets,maps } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

const bsUrl = require("../../../assets/icons/ais/ais-bs.svg")

@Component({
  components: {
    LGeoJson,
  },
})
export default class BaseStationLayer extends Vue {
  //computed
  get geoJsonOptions() {
    return {
      pointToLayer: this.bsPoint,
      onEachFeature: this.onEachFeatureFunction,
    };
  }
  get onEachFeatureFunction() {
    return (feature: IBaseStation, layer: Layer) => {
      layer.bindTooltip("Estación base: " + feature.mmsi, {
        permanent: false,
        sticky: true,
      });
      layer.on("click", (response: LeafletMouseEvent) => {
        if (maps.getters.measurementActivated) {
          maps.commit(MutationTypes.ADD_MEASUREMENT_POINT, {
            tipo: "bs",
            data: response.latlng,
          });
        }
      });
    };
  }
  get bsPoint() {
    return (feature: IBaseStation, latlng: LatLng) => {
      let bsIcon = new Icon({
        iconSize: [60, 60],
        iconUrl: bsUrl,
      });
      return marker(latlng, { icon: bsIcon });
    };
  }
  get baseStations() {
    return targets.getters.bsList;
  }

  loadFeatures() {
    targets.dispatch("getBaseStations");
  }

  created() {
    this.loadFeatures();
  }
}
